import { createFileRoute } from '@tanstack/react-router'

import { PortalSpecSection } from '@/components/portal/portal-spec-section'

export const Route = createFileRoute('/portal/projets/$projectId_/cahier/$key')({
  component: PortalSpecSectionRoute,
})

function PortalSpecSectionRoute() {
  const { projectId, key } = Route.useParams()
  return <PortalSpecSection key={key} projectId={projectId} sectionKey={key} />
}
